import { createAppWrap } from '../../create_app_wrap';
import flashMessageMixin from '../../mixins/_flash_messages';
import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import chromeExtensionMixin from '../../mixins/_chrome_extension';
import microcmsMixin from '../../mixins/_microcms';
import updateStorecreatorData from '../../components/_update_storecreator_data';
import modalBillInfoEditor from '../../components/_modal_bill_info_editor';
import tasks from '../../pages/guide/_tasks';

// userContractステータス
const STATUS = {
    TRIAL: 1,
    EXPIRED_TRIAL: 2,
    CONTINUATION_RECEPTION: 3,
    CONTINUATION: 4,
    CANCELLATION_RECEPTION: 5,
    CANCELLATION: 6,
    REAPPLICATION: 12,
};

// 「今日のニュース・イベント」コンテンツ数
const TODAY_NEWS_CONTENTS_NUM = 5;

// タグ名、クラス紐づけ
const TAGS = [
    ['重要', 'bg-danger'],
    ['お知らせ', 'bg-secondary'],
    ['新機能', 'bg-success'],
    ['メンテナンス', 'bg-warning'],
    ['不具合', 'bg-danger'],
    ['改善', 'bg-primary'],
];


const view = '[data-view="menu"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                userContract: null,
                billing: null,
                // 開店済みフラグ
                opened: null,
                // タスクコンテンツ表示フラグ
                show_task: true,
                // 「お知らせ」コンテンツ
                information_contents: null,
                // 「今日のニュース・イベント」コンテンツ
                today_news_contents: null,
                // トライアル終了まであと何日か
                trialend_days: null,
            };
        },
        computed: {
            // トライアル終了14日前か
            beforeTrialExpired: function () {
                var now = moment();
                var expired_date = moment(this.userContract.trial_end);
                this.trialend_days = expired_date.diff(now, 'days');
                if (this.userContract.status === STATUS['TRIAL'] && this.trialend_days <= 14) {
                    return true;
                }
                return false;
            },
            // 再申込か
            isReapply: function () {
                return this.userContract.status === STATUS['REAPPLICATION'];
            }
        },
        /**
         * コンポーネント
         */
        components: {
            'modal-bill-info-editor': modalBillInfoEditor,
            // タスクコンポーネント
            'tasks': tasks,
            // ストアクリエイターからデータを取得するコンポーネント
            'update-storecreator-data': updateStorecreatorData,
            // 「お知らせ」コンポーネント
            'information-contents': {
                template: '#information_compornent_template',
                data () {
                    return {
                        selected_content: {},
                    };
                },
                props: {
                    // お知らせ用画像情報
                    image_data: {
                        type: [Object, Array],
                        required: true,
                    },
                    // コンテンツ
                    contents: {
                        type: [Array, null],
                        default: () => ({}),
                        required: true,
                    },
                    // 開店状況
                    is_opening: {
                        type: Boolean,
                        default: false,
                        required: true,
                    }
                },
                mixins: [
                    commonMixin,
                    modalMixin,
                ],
                methods: {
                    // 公開日時をフォーマットする
                    formatPublisheddAt: function (publishedAt) {
                        return moment(publishedAt).format('YYYY.MM.DD');
                    },
                    // タグに対応するclass名を取得する
                    getTagClass: function(tagName) {
                        const targetTag = TAGS.find(function(tag) {
                            return (tag[0] === tagName);
                        });
                        return targetTag[1];
                    },
                    // モーダルを開く
                    openModal: function (content) {
                        this.selected_content = content;
                        this.open();
                    },
                },
            },
        },
        /**
         * ミックスインオブジェクト
         */
        mixins: [
            commonMixin,
            flashMessageMixin,
            modalMixin,
            chromeExtensionMixin,
            microcmsMixin,
        ],
        created: function() {
            // ブラウザバックによる遷移の時リロードする
            if (this.isBackBorward()) {
                window.location.reload();
            }

            const userContractData = document.querySelector('[data-roll="userContract"]');
            if (userContractData) {
                this.userContract = JSON.parse(userContractData.innerHTML);
            }
            const billingData = document.querySelector('[data-roll="billing"]');
            if (billingData) {
                this.billing = JSON.parse(billingData.innerHTML);
            }
        },
        mounted: async function () {
            await this.isUnPaid();
            this.getInformation();
            this.getTodayNews();

            // ステータスが再申込の時、再申込モーダルを表示
            if(this.isReapply) {
                this.iniModal('#modal-reapply-confirm');
                this.open();
            }
        },
        /**
         * 各種メソッド
         */
        methods: {
            // 開店済みフラグを更新
            updateOpenedFlag: async function (bool) {
                // 未開店 -> 開店の時はalert表示
                if (this.opened === false && bool) {
                    this.sendAfterOpenFollowMail();
                    await swal('おめでとうございます！ ご開店を確認しました。\n「カスタムページ」「バナーをつくる」機能が利用できるようになりました。');
                }
                this.opened = (bool) ? true : false;
            },
            // 開店したことのフォローメールを送る
            async sendAfterOpenFollowMail () {
                this.$_loading();
                try {
                    await axios.get('/menu/send_follow_mail');
                } catch {
                    // エラーが発生してもユーザーには通知しない
                }
                this.$_unloading();
            },
            // 未払い状態かを判定
            async isUnPaid () {
                let message = this.exception_error_message;
                try {
                    const response = await axios.get('/billing/is_unpaid', {
                        _method: 'GET'
                    });
                    if (response.data) {
                        // 未払いの場合
                        message = '今月のご利用料金お支払いに失敗しました。「ご契約・登録情報」メニューより、月末までにお支払いをお願いします。';
                    }else{
                        message = '';
                    }

                } catch (e) {
                    message = this.getCatchMessage(e);
                }
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    });
                }
            },
            // microCMS「お知らせ」を取得する
            getInformation: async function () {
                try {
                    this.information_contents = await this.getMicrocmsContents('information', 30, 'desc');
                } catch (e) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: this.getCatchMessage(e),
                    });
                }
            },
            // microCMS「今日のニュース・イベント」を取得する
            getTodayNews: async function () {
                this.$_loading();
                try {
                    const response = await axios.get('/menu/get_today_news', {
                        params: {
                            _method: 'GET',
                            end_point: 'news',
                            contents_num: TODAY_NEWS_CONTENTS_NUM,
                        }
                    });
                    if (response.data.status === 'OK') {
                        this.today_news_contents = response.data.data;
                    }
                } catch (e) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: this.getCatchMessage(e),
                    });
                } finally {
                    this.$_unloading();
                }
            },
            /**
            },
            * 「支払いに進む」ボタンクリック時処理
            */
            clickedPaymentBtn: function() {
                this.close();
                this.$refs.billInfoEditor.open();
            },
            /**
            * 「決済して利用をはじめる」ボタンクリック時処理
            */
            async submitBilling (postParams) {
                try {
                    // ローディングスクリーン表示
                    this.$_loading();
                    const response = await axios.post('/billing/reapply', {
                        _method: 'POST',
                        staff_name: postParams.staff_name,
                        email: postParams.email,
                        token: postParams.token
                    });

                    if (response.data.status === 'OK') {
                        // 支払い情報編集モーダル非表示
                        this.$refs.billInfoEditor.close();

                        this.clearFlashMessage();
                        // フラッシュメッセージ表示
                        this.appendFlashMessage({
                            level: 'alert-success',
                            message: 'ご契約手続きを完了しました。有り難うございます。',
                        });
                    } else {
                        this.appendFlashMessage({
                            level: 'alert-danger',
                            message: response.data.message,
                        });
                    }
                } catch (e) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: this.getCatchMessage(e),
                    });
                } finally {
                    // ローディングスクリーン非表示
                    this.$_unloading();
                }
            },
            // ブラウザバック（次へ含む）による遷移か
            isBackBorward: function() {
                let type;
                const navigationEntries = performance.getEntriesByType('navigation');
                navigationEntries.forEach(function(navigation) {
                    type = navigation.type;
                });
                // ブラウザバックの場合true
                return (type === 'back_forward');
            },
            // 画像のフルパスを返却する
            getImageFullPath (imagePath){
                return this.config.storage_path + '/' + imagePath;
            }
        }
    });
};

if (document.querySelector(view)) {
    init();
}
